import { render, staticRenderFns } from "./CategNews.vue?vue&type=template&id=704f1d43&scoped=true&"
import script from "./CategNews.vue?vue&type=script&lang=js&"
export * from "./CategNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704f1d43",
  null
  
)

export default component.exports